// extracted by mini-css-extract-plugin
module.exports = {"container":"ConnectionErrorDialog_container__V3dKZ","header":"ConnectionErrorDialog_header__tIGL5","text":"ConnectionErrorDialog_text__mg8bU"};